// ONLY USING COLORS IN THIS FILE FOR NOW
// text styles can be found in textStyles.ts

const colors = {
  colorBlack: 'rgba(29, 29, 29, 1)',
  colorLightBlack: 'rgba(51, 51, 51, 1)',
  colorWhite: 'rgba(255, 255, 255, 1)',
  colorVeryDarkGray: 'rgba(86, 94, 105, 1)',
  colorDarkGray: 'rgba(123, 132, 142, 1)',
  colorMedDarkGray: 'rgba(162, 168, 175, 1)',
  colorMedGray: 'rgba(206, 212, 219, 1)',
  colorLightGray: 'rgba(225, 231, 238, 1)',
  colorVeryLightGray: 'rgba(249, 249, 249, 1)',
  colorLime: 'rgba(161, 202, 46, 1)',
  colorMedBlue: 'rgba(40, 142, 186, 1)',
  colorDarkBlue: 'rgba(15, 77, 104, 1)',
  colorVeryDarkBlue: 'rgba(2, 37, 52, 1)',
  colorLightBlue: 'rgba(121, 207, 244, 1)',
  colorBrightLime: 'rgba(173, 229, 34, 1)',
}
export default colors
